import classNames from 'classnames';
import React, { memo } from 'react';
import Highlighter from 'react-highlight-words';
import { Button, ButtonGroup, DialogFooter, DialogHeader, Message } from '@wg/wows-react-uikit';

import settings, { highlighterPercentRegexp } from '~/settings';
import { t } from '~/helpers/localization';

import { Center } from '~/UIKit';

import styles from './Footer.module.scss';

import type { BUILDINGS } from '~/Actions/ActionSupply';
import type { Nullable } from '~/types/generics';

interface PropsType {
  isOwnBase: boolean;
  level: Nullable<number>;
  bonuses: Nullable<string[]>;
  confirmBuildingId: Nullable<BUILDINGS>;
  selectedBuildingId: Nullable<BUILDINGS>;
  tempHoverBuildingId: Nullable<BUILDINGS>;
  dropSelection: () => void;
  navigateToTreasury: () => void;
}

const Footer: React.FC<PropsType> = ({
  bonuses,
  confirmBuildingId,
  isOwnBase,
  level = 0,
  selectedBuildingId,
  tempHoverBuildingId,
  dropSelection,
  navigateToTreasury,
}) => {
  const hasBonuses = bonuses && bonuses.some((bonus) => !!bonus);

  const renderTitle = () => {
    if (level === 0 || !hasBonuses) {
      return null;
    }

    if (confirmBuildingId || tempHoverBuildingId) {
      const title = bonuses.length === 1 ? t('Улучшение дает следующий бонус') : t('Улучшение дает следующие бонусы');
      return <DialogHeader noUnderline>{title}</DialogHeader>;
    } else {
      return <DialogHeader noUnderline>{t('Активные бонусы строения')}</DialogHeader>;
    }
  };

  const isTreasurySelected = selectedBuildingId === 'treasury';
  const bundlesEnabled = settings.treasury?.bundlesEnabled ?? false;
  const showTreasuryButton = isTreasurySelected && bundlesEnabled && isOwnBase && !tempHoverBuildingId && level! > 0;

  const renderBonuses = () => {
    if (!hasBonuses) {
      return null;
    }

    return bonuses.map((bonus, index) => {
      if (!bonus) {
        return null;
      }

      return (
        <Message key={`bonus-${index}`} style={'fullsize'} type={'none'}>
          <Highlighter
            highlightClassName="HighlightPercent"
            searchWords={highlighterPercentRegexp}
            textToHighlight={bonus}
          />
        </Message>
      );
    });
  };

  return (
    <div
      className={classNames(styles.buildingBottomInfo, {
        [styles.isShow]: selectedBuildingId,
      })}
    >
      {renderTitle()}

      <Center>
        {renderBonuses()}
        <span className={styles.topWrapper}></span>
      </Center>
      {level === 0 && (
        <Center>
          <span className={styles.notBuiltFooterStatus}>{t('Здание не построено')}</span>
        </Center>
      )}

      <DialogFooter>
        <ButtonGroup>
          <Button isFlat onClick={dropSelection}>
            {t('Вернуться на базу')}
          </Button>
          {showTreasuryButton && (
            <Button isFlat onClick={() => navigateToTreasury()}>
              {t('Перейти в казну')}
            </Button>
          )}
        </ButtonGroup>
      </DialogFooter>
    </div>
  );
};

export default memo(Footer);
